import { render, staticRenderFns } from "./NotificationTemplateAdd.vue?vue&type=template&id=239043d5&scoped=true"
import script from "./NotificationTemplateAdd.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateAdd.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateAdd.vue?vue&type=style&index=0&id=239043d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239043d5",
  null
  
)

export default component.exports